const SERVICES = [
  {
    num: "01 / DESIGN",
    title: "Landscape Design",
    desc: "Complete spatial drafting, plant selection, and architectural hardscape layout.",
    caption: "Architectural Yard Design",
    img: "https://images.unsplash.com/photo-1635108201275-b1863fcb9eeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxyZXNpZGVudGlhbCUyMGxhbmRzY2FwZSUyMHlhcmR8ZW58MHx8fHwxNzkyOTYxNzQxfDA&ixlib=rb-4.1.0&q=85",
    alt: "Custom residential landscape design and finished yard layout",
  },
  {
    num: "02 / STRUCTURE",
    title: "Hardscaping",
    desc: "Custom stone pavers, retaining walls, walkways, and outdoor living structures.",
    caption: "Stone Pavers & Masonry",
    img: "https://images.unsplash.com/photo-1790426540560-081e8c62c563?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxzdG9uZSUyMHBhdGlvJTIwcGF2ZXJzJTIwcmV0YWluaW5nJTIwd2FsbHxlbnwwfHx8fDE3OTI5NjE3NDF8MA&ixlib=rb-4.1.0&q=85",
    alt: "Stone patio paver installation with retaining wall",
  },
  {
    num: "03 / HYDRAULICS",
    title: "Irrigation Systems",
    desc: "Smart controllers, drip conversion, automated zone lines, and fast leak repair.",
    caption: "Smart Water Systems",
    img: "/images/photo_8.jpg",
    alt: "Sahagun Landscape crew replacing irrigation lines and valves on a commercial property",
  },
  {
    num: "04 / ARBORICULTURE",
    title: "Tree Services",
    desc: "Precision canopy trimming, specimen planting, limb bracing, and safe removal.",
    caption: "Canopy Care & Pruning",
    img: "https://images.unsplash.com/photo-1519909709805-54df302f447b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHx0cmVlJTIwdHJpbW1pbmclMjBwYWxtJTIwY2FyZXxlbnwwfHx8fDE3OTI5NjE3NDF8MA&ixlib=rb-4.1.0&q=85",
    alt: "Professional tree trimming and palm care",
  },
  {
    num: "05 / LAWN ALTERNATIVE",
    title: "Turf & Sod Installation",
    desc: "Water-wise artificial turf or fresh hybrid sod with base grading and drainage.",
    caption: "Synthetic & Natural Lawns",
    img: "/images/photo_2.jpg",
    alt: "Artificial turf installed along a commercial walkway by Sahagun Landscape",
  },
  {
    num: "06 / ONGOING",
    title: "Full Service Maintenance",
    desc: "Scheduled commercial groundskeeping and residential garden detailing.",
    caption: "Scheduled Property Care",
    img: "/images/photo_3.jpg",
    alt: "Fresh commercial campus lawn maintained by Sahagun Landscape",
  },
];

const ServiceCard = ({ service, delay }) => (
  <article
    className={`reveal ${delay} p-8 bg-[#f2ece1] border border-[#2d4a22]/10 flex flex-col justify-between group hover:border-[#2d4a22] transition-colors`}
    data-testid={`service-card-${service.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
  >
    <div>
      <span className="font-mono-type text-xs text-[#2d4a22] font-semibold block mb-4">{service.num}</span>
      <h3 className="text-xl font-bold uppercase mb-2">{service.title}</h3>
      <p className="text-sm text-[#3d4b3b]">{service.desc}</p>
    </div>
    <figure className="img-zoom mt-8 aspect-[16/9] bg-[#e4dacb] relative overflow-hidden border border-[#2d4a22]/10">
      <img src={service.img} alt={service.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <figcaption className="absolute bottom-0 left-0 right-0 p-4 text-[11px] uppercase tracking-widest text-[#faf8f5] bg-gradient-to-t from-[#1f281e]/80 to-transparent">
        {service.caption}
      </figcaption>
    </figure>
  </article>
);

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#faf8f5] text-[#1f281e]">
    <div className="max-w-6xl mx-auto px-6">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
        <div className="reveal">
          <span className="font-mono-type text-xs uppercase tracking-[0.18em] text-[#2d4a22] font-semibold block mb-2">
            Scope of Capabilities
          </span>
          <h2 className="font-display text-3xl md:text-5xl uppercase text-[#1f281e]">Residential &amp; Commercial</h2>
        </div>
        <p className="reveal reveal-d1 text-sm text-[#3d4b3b] max-w-sm">
          One dedicated crew taking projects from architectural grading to weekly year-round care.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.title} service={s} delay={`reveal-d${(i % 3) + 1}`} />
        ))}
      </div>
    </div>
  </section>
);
